// extracted by mini-css-extract-plugin
export default {"editCommentFormFields":"xJk6RpvnDl"};